export default __webpack_public_path__ + "static/media/snake_three.4b776eeb.png";